import React, { useEffect, useState, useMemo } from "react";
import "./HeroBanner.css";
import { useNavigate } from "react-router-dom";

const MAX_VISIBLE = 12;

const HeroBanner = () => {
  const [industries, setIndustries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL || ""}/api/industries`);
        const data = await res.json();
        if (!isMounted) return;
        setIndustries(data.industries || []);
      } catch (err) {
        console.error("Virhe toimialojen haussa:", err);
        if (isMounted) setError("Toimialojen haku epäonnistui.");
      } finally {
        if (isMounted) setLoading(false);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, []);

  const list = useMemo(
    () => (expanded ? industries : industries.slice(0, MAX_VISIBLE)),
    [industries, expanded]
  );

  const onChipActivate = (industryId) => {
    // Ohjataan suoraan CatalogPageen oikealla industry-id:llä
    navigate(`/catalog?ind=${industryId}`);
  };

  return (
    <section className="hero-banner" aria-labelledby="hero-title">
      <h1 id="hero-title">Tilaa yhdessä tehokkaammin</h1>

      <p className="hero-lead">
        Fourplifyn yhteisöllinen tilausmalli yhdistää yrityksesi hankinnat muiden kanssa ja
        mahdollistaa säästöt, joita et muuten saavuttaisi.
      </p>

      <div className="industry-select-wrapper">
        <p className="hero-label">Aloita valitsemalla toimialasi:</p>

        {/* CHIPS */}
        <ul className="chipRow" aria-label="Toimialat">
          {loading &&
            Array.from({ length: 2 }).map((_, i) => (
              <li key={`sk-${i}`}>
                <span className="chip chip--skeleton" aria-hidden="true" />
              </li>
            ))}

          {!loading &&
            !error &&
            list.map((ind) => (
              <li key={ind._id}>
                <button
                  type="button"
                  className="chip"
                  aria-label={`Siirry toimialalle: ${ind.name}`}
                  onClick={() => onChipActivate(ind._id)}
                >
                  {ind.name}
                </button>
              </li>
            ))}

          {!loading && !error && industries.length > MAX_VISIBLE && (
            <li>
              <button
                type="button"
                className="chip chip--ghost"
                onClick={() => setExpanded((v) => !v)}
                aria-expanded={expanded}
              >
                {expanded ? "Näytä vähemmän" : `Näytä kaikki (${industries.length})`}
              </button>
            </li>
          )}

          {!loading && error && (
            <li>
              <span className="chip chip--error" aria-live="polite">
                {error}
              </span>
            </li>
          )}
        </ul>

        {/* Fallback-select saavutettavuuden/progressiivisuuden vuoksi */}
        <div className="sr-only" aria-hidden="true">
          <label htmlFor="industrySelect">Valitse toimiala:</label>
          <select
            id="industrySelect"
            onChange={(e) => {
              const found = industries.find((x) => x._id === e.target.value);
              if (found) onChipActivate(found._id);
            }}
            defaultValue=""
          >
            <option value="" disabled>
              Valitse toimiala
            </option>
            {industries.map((ind) => (
              <option key={ind._id} value={ind._id}>
                {ind.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;
